(function(document, window, $) {
    'use strict';

    var Site = window.Site;

    $(document).ready(function($) {
        Site.run();

        var k=0;
        $(document).on('mouseenter', '[data-has=popover]', function (e) {

            var $e = $(this);
           // if ($e.attr('aria-descibedby')!= undefined) return;
            var id = $(this).data('id');
            k++;

            var div_id =  "tmp-id-" + $.now();
            var content = '<div id="'+ div_id +'" class="popover-wrapper"><div class="height-10 text-center"><div class="loader loader-default"></div></div></div>';

            popupDetails($(this).attr('data-pophref'), div_id, $e);

            var container = false;
            if ($(this).closest('.slidePanel').length) container = '.slidePanel';
            $e.popover({
                    "placement": "bottom",
                    "trigger": "manual",
                    "html": true,
                    "container": container,
                    //"title": 'this is a title test '+k,
                    "content": content
                }).popover('show');
        });

        $(document).on('mouseleave','[data-has=popover]', function(e){
            var $that = $(this);
         //   setTimeout(function() {
                var target = $that.attr('aria-describedby');
                $('#' + target).popover('destroy');
          //  }, 500);
        });

        $(document).on('click','[data-has=popover]', function(e){
            var target = $(this).attr('aria-describedby');
            $('#'+target).popover('destroy');
        });




        window.popupDetails = function(link, div_id, $e){

            if (link!=undefined)
            $.ajax({
                url: link,
                success: function(response){
                    $('#'+div_id).html(response);
                  //  $e.popover('show');
                }
            });
        }

    })

})(document, window, jQuery);
